<template>
  <header :class="selector"
          class="page-header">
    <div class="page-header__inner">
      <div class="page-header__panel">
        <div class="page-header__panel-inner">
          <div class="page-header__col">
            <div class="page-header__col-inner">
              <a href="#" class="page-header__link _menu" @click.prevent="onMenuToggle">
                <span class="menu-ico">
                  <i class="fa fa-bars"></i>
                  <i class="fa fa-close"></i>
                </span>
                <span class="page-header__link-text d-lg-none">{{ $t('Меню') }}</span>
              </a>

              <a :href="`tel:${settings.phone}`" class="page-header__link d-sm-none">
                <i class="fa fa-phone"></i>
                <span class="page-header__link-text">{{ settings.phone }}</span>
              </a>
              <router-link :to="{name: 'delivery', params: {restaurantId: activeRestaurantId}}" class="page-header__link _delivery d-sm-none">
                <div class="delivery-img-wrap">
                  <img src="../assets/images/auto-1.png" alt="delivery">
                </div>
                <span class="page-header__link-text" style="text-transform: uppercase"><span>{{ $t('Доставка') }}</span>
                  <span class="page-header__delivery-place" v-if="active_restaurant"
                        @click.prevent="onSelectPlace"><span>{{ active_restaurant.category && active_restaurant.category.name || active_restaurant.title }}</span> <i
                    class="fa fa-angle-down"></i></span></span>
              </router-link>
            </div>
          </div>
          <div class="page-header__col">
            <div class="page-header__col-inner">

              <div v-if="$route.name === 'home'"
                   class="page-header__logo">
                <img src="../assets/images/logos.jpg" alt="classic"/>
              </div>
              <router-link
                v-else
                class="page-header__logo"
                :to="{name: 'home'}">
                <img src="../assets/images/logos.jpg" alt="classic"/>
              </router-link>
            </div>
          </div>
          <div class="page-header__col">

            <div class="page-header__col-inner">
              <router-link :to="{name: 'basket'}" class="page-header__link">
                <keep-alive>
                  <span
                    class="page-header__link-label"
                    :class="basketItemsCounter < 1 ? '_hide' : null"
                  >{{ basketItemsCounter }}</span
                  >
                </keep-alive>
                <i class="fa fa-shopping-basket"></i>
                <span class="page-header__link-text" v-if="productsPrice">{{ productsPrice | formatPrice }} {{
                    $t('грн')
                  }}</span>
              </router-link>
              <router-link v-if="isLogged"
                           :to="{name: 'account'}"
                           class="page-header__link">
                <i class="fa fa-user"></i>
                <span class="page-header__link-text d-sm-none">{{ $t('Кабінет') }}</span>
              </router-link>
              <a v-else
                 href="#login"
                 @click.prevent="onOpenLogin"
                 class="page-header__link">
                <i class="fa fa-user"></i>
                <span class="page-header__link-text d-sm-none">{{ $t('Вхід') }}</span>
              </a>
              <LangSelect class="d-sm-none"/>
            </div>
          </div>
        </div>
      </div>
      <transition name="dropdown-big">
        <HeaderToggle v-if="isMenuOpen" v-click-out="onMenuClose"/>
      </transition>
    </div>
  </header>
</template>

<script>
  import HeaderToggle from './HeaderToggle'
  import LangSelect from './LangSelect'
  import {mapState} from 'vuex'
  import getBasketItemPrice from '@/helpers/getBasketItemPrice'
  //import getBasketItemPackingPrice from '@/helpers/getBasketItemPackingPrice'

  export default {
    name: 'TheHeader',
    components: {LangSelect, HeaderToggle},
    data() {
      return {
        headerHeight: 100,
        scrollPosition: 0,
        sticky: false,
        isMenuOpen: false
      }
    },
    computed: {
      ...mapState('basket', ['basket']),
      ...mapState('restaurants', ['active_restaurant']),
      activeRestaurantId() {
        let id = window.localStorage.getItem('active_restaurant_id') || null
        if (this.active_restaurant) {
          id = this.active_restaurant.id
        }
        return id
      },
      productsPrice() {
        let totalPrice = 0

        this.basket.forEach((item) => {
            //totalPrice += getBasketItemPrice(item) + getBasketItemPackingPrice(item) * item.quantity
            totalPrice += getBasketItemPrice(item) * item.quantity
        })
        return totalPrice
      },
      selector() {
        return {
          '_sticky': this.sticky,
          '_open': this.isMenuOpen
        }
      },
      isLogged() {
        return this.$store.getters['user/isLogged']
      },
      settings() {
        return this.$store.state.settings.settings
      },
      basketItemsCounter() {
        return this.basket.reduce(
          (accumulator, current) => accumulator += current.quantity,
          0
        )
      },
    },
    methods: {
      setScrollPosition() {
        this.scrollPosition = window.pageYOffset
      },
      onMenuToggle() {
        this.isMenuOpen = !this.isMenuOpen
      },
      onMenuClose() {
        this.isMenuOpen = false
      },
      onOpenLogin() {
        this.$vModal.open('auth-login', {
          redirect: {name: 'account'}
        })
      },
      checkSticky() {
        if (this.scrollPosition > this.headerHeight) {
          if (!this.sticky) this.sticky = true
        } else {
          if (this.sticky) this.sticky = false
        }
      },
      onSelectPlace() {
        this.$vModal.open('select-place')
      }
    },
    mounted() {
      window.addEventListener('scroll', this.setScrollPosition)
      this.checkSticky()
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.setScrollPosition)
    },
    created() {
      this.$store.dispatch('restaurants/load')
    },
    watch: {
      '$route'() {
        this.onMenuClose()
      },
      scrollPosition() {
        this.checkSticky()
      }
    }
  }
</script>

<style>

</style>
